// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__6zhjr","name":"style_name__30M1A","description":"style_description___22nA"};